import { render } from "./ArrowCircleIcon.vue?vue&type=template&id=56c74f55&scoped=true"
import script from "./ArrowCircleIcon.vue?vue&type=script&lang=js"
export * from "./ArrowCircleIcon.vue?vue&type=script&lang=js"

import "./ArrowCircleIcon.vue?vue&type=style&index=0&id=56c74f55&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c74f55"]])

export default __exports__